export const COOKIE = 'COOKIE';
